import _ from 'lodash'

import { valueTable as commonConfigValues } from './commonConfig'

const { decision, trainingType, trainingFrequency } = commonConfigValues

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const valueTable = {
  trainingType,
  trainingFrequency
}

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'person.fullName',
      'training.type',
      'training.name',
      'training.date',
      'training.flag'
    ]
  }
]

export const columns = [
  {
    name: 'id',
    title: 'ID',
    hidden: true,
    formField: true
  },
  {
    name: 'register.personId',
    title: 'YP UI',
    minSpace: 'YP UIw ',
    formField: true
  },
  {
    name: 'register.person.firstName',
    title: 'YP First Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.lastName',
    title: 'YP Last Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.fullName',
    title: 'YP Name',
    formField: true,
    getCellValue: row =>
      `${row['register.person.firstName']} ${row['register.person.lastName']}`,
    maxChars: 100,
    minSpace: 'YP Name '
  },
  {
    name: 'training.type',
    title: 'YP Training Type',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(trainingType, ['id', parseInt(row[`training.type`], 10)])
        ? _.find(trainingType, ['id', parseInt(row[`training.type`], 10)]).label
        : row[`training.type`],
    options: 'trainingType',
    filterField: true,
    minSpace: 'YP Training Type '
  },
  {
    name: 'training.name',
    title: 'YP Training Name',
    formField: true,
    type: 'select',
    options: 'trainingNames', //USERS MODIFIED LIST
    multiple: true,
    filterField: true,
    minSpace: 'YP Training Name '
  },
  {
    name: 'training.frequency',
    title: 'YP Training Frequency Minimum',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(trainingFrequency, ['id', parseInt(row[`training.frequency`], 10)])
        ? _.find(trainingFrequency, [
            'id',
            parseInt(row[`training.frequency`], 10)
          ]).label
        : row[`training.frequency`],
    options: 'trainingFrequency',
    filterField: true,
    minSpace: 'Frequency Minimum '
  },
  {
    name: 'training.evidence',
    title: 'Training Evidence on File',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`training.evidence`], 10)])
        ? _.find(decision, ['id', parseInt(row[`training.evidence`], 10)]).label
        : row[`training.evidence`],
    options: 'decision',
    filterField: true,
    minSpace: 'Evidence on File '
  },
  {
    name: 'training.date',
    title: 'Training Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Training '
  },
  {
    name: 'training.flag',
    title: 'Training Flag',
    formField: true,
    filterField: true,
    minSpace: 'Training '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'training',
      historyName: 'trainingHistory',
      label: 'Register',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registerId',
          disabled: !add,
          label: 'Register Entry',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.register.filter(f => f.id > 0).map(o => {
            const person = _.find(availableValues.persons, ['id', o.personId])
            const label = `${person.firstName} ${person.lastName} (register: ${
              o.id
            })`
            return { value: o.id, label: label }
          })
        }
      ]
    },

    {
      id: 2,
      name: 'trn',
      activeName: 'training',
      historyName: 'trainingHistory',
      label: 'Trainings',
      icon: 'note',
      fields: [
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'training.type',
            label: 'YP Training Type',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.trainingType
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'training.name',
            label: 'YP Training Name',
            multiple: true,
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.trainingnames
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          }
        ],
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'training.frequency',
          label: 'YP Training Frequency Minimum',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.trainingFrequency
            .filter(f => f.id > 0)
            .map(o => {
              return { value: o.id, label: o.label }
            })
        },
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'training.evidence',
          label: 'Training Evidence on File',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.decision.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        },
        {
          type: fields.datepicker,
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'training.date',
          label: 'Training Date',
          required: showAsterix,
          openToYearSelection: openToYearSelection,
          hideCalendarDate: hideCalendarDate,
          textFieldStyle: { width: '100%', ...styles.fieldText },
          validate: v => (v ? undefined : 'Field is required')
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          disabled: true,
          name: 'training.flag',
          label: 'Training Flag'
        }
      ]
    }
  ]

  return forms
}

export const activeSection = ['training']

export const errors = [1, 2]

export const defaultNew = {
  training: {
    historyId: 'new'
  },
  trainingHistory: []
}

// "trainings": [
//   {
// "training": {
//   "id": 1,
//   "registerId": 1, //  ->  "personId": 2 -> person,
//   "date": "2001-01-01T23:28:56.782Z",
//   "type": 2,
//   "name": 5,
//   "frequency" : 2,
//   "evidence" :2,
//   "flag": "dd"
// },
// "trainingHistory": {

// }
//   }
// ]



// WEBPACK FOOTER //
// ./src/register/configs/trainings.js